<template>
  <component
    :is="tag"
    @click="emitChildItemObject(paramsObject)"
    class="p-the-header-navi-on-general__link"
    v-touch:tap
  >
    <i v-if="$slots.icon" class="p-the-header-navi-on-general__link__icon">
      <slot name="icon" />
    </i>

    <span
      class="p-the-header-navi-on-general__link__text"
      :class="childClassName"
    >
      <slot name="label" />
    </span>

    <i class="p-the-header-navi-on-general__link__arrow">
      <IconBase
        :width="24"
        :height="24"
        view-box="0 0 24 24"
        icon-color="#000000"
      >
        <IconArrowRight />
      </IconBase>
    </i>
  </component>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";

import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { Options, Vue } from 'vue-class-component';
import { PropSync, Emit } from 'vue-property-decorator';

@Options({
  props: {
    tag: { type: String, default: "button" },
    paramsObject: { type: Object, required: true },
    isChildItem: { type: Boolean, default: true }
  },
  components: {
    IconBase,
    IconArrowRight
  }
})
export default class CategoryNaviItemLink extends Vue {
  tag!: string;
  paramsObject!: Record<string, any>;
  isChildItem!: boolean;

  get childClassName() {
    const isChildItem = this.isChildItem;
    return isChildItem ? "p-the-header-navi-on-general__link__text--child" : "";
  }

  emitChildItemObject(emitValue: any) {
    this.$emit("emit-child-item-object", emitValue);
  }
}
</script>
